export const META_DESCRIPTION = {
    base: () => 'PROFFITはコンサル選定支援サービスです。累計80億円以上のコンサル相談実績があり、500社以上のコンサルティング会社から依頼内容や費用水準に合わせて最適なコンサルチームを選定することが出来ます。',
    columnList: () => 'PROFFITのコラムページでは、コンサル選定のコツや、プロジェクトの依頼事例をご紹介。初めてコンサルを活用される方にも安心してご利用いただくための資料を公開しています。',
    company: () => '外部コンサルの活用でお悩みなら【PROFFIT】へ。【PROFFIT】は組織の発展を支援する最高のチームを見つけられる業界初のコンサル選定支援サービスです。コンサル探しからプロジェクト成約まで課題解決のベストパートナー探しをご支援します。',
    documentList: () => 'PROFFITのダウンロード資料ページでは、コンサル選定のコツや、プロジェクトの依頼事例をご紹介。初めてコンサルを活用される方にも安心してご利用いただくための資料を公開しています。',
    forConsultant: () => 'PROFFITはコンサル選定支援サービスです。過去700件以上の支援実績をもとに、リアルなコンサル選びの実例をご紹介します。',
    hotline: {
        base: () => '外部コンサルの活用でお悩みなら【PROFFIT】へ。【PROFFIT】は組織の発展を支援する最高のチームを見つけられる業界初のコンサル選定支援サービスです。コンサル探しからプロジェクト成約まで課題解決のベストパートナー探しをご支援します。',
        lp: () => '今すぐ解消したい、ビジネスのモヤモヤに。匿名コンサルホットライン。業務に行き詰ったとき、近くに相談できる人がいないなら知見・実績豊富なコンサルタントに1時間から匿名で、気軽に相談できます。',
    },
    law: () => '事業者の名称 合同会社Co-nnect Inc. 代表者名 代表：関根有 所在地 〒103-0006 東京都中央区日本橋富沢町10-13 & WORK NIHONBASHI 5F',
    seminarList: () => 'コンサル選定支援サービスのPROFFIT。セミナー検索ページでは、コンサルティング会社が主催する様々なテーマのセミナー・勉強会・ワークショップを検索することが出来ます。',
    terms: () => '本利用規約は、合同会社Co-nnect Inc.（以下「当社」といいます。）が本サービス及び本サービスサイトについての利用条件を定めるものであり、本サービスの利用にかかる当社と本サービスの登録会員との一切の関係に適用されます。',
};
